<script>
    import localTime from "../stores/localTime.js";
    import { dayProgress } from "../helpers/time.js";
    import { ease, gradientCssAt } from "../helpers/color.js";
    import createLogotype from "../logotype.js";
    import { getInitialKansasWallpaperProgress } from "../helpers/wallpaperCanvas.js";

    let canvas;
    let forceProgress;
    let animateProgress;

    $: canvas && createLogotype(canvas, forceProgress || progress);

    window.setProgress = (p) => {
        forceProgress = ease(p);
    };

    window.setHours = (hours) => {
        const date = new Date();
        date.setHours(hours);
        const p = dayProgress(date);
        setProgress(p);
    };

    window.animateProgress = (from, to, speed) => {
        let p = from;

        function update() {
            forceProgress = p;
            p += speed;

            if (p < to) {
                requestAnimationFrame(update);
            }
        }

        update();
    };

    const defaultProgress = getInitialKansasWallpaperProgress();

    let progress = defaultProgress;

    localTime.subscribe((time) => {
        if (forceProgress) {
            return;
        }

        if (!time) {
            return;
        }

        const { progress: next } = time;

        if (next === progress) {
            return;
        }

        function animate() {
            if (next - progress > 0.25) {
                progress = next;
            } else if (progress < next) {
                progress += 0.001;
            } else {
                progress = next;
            }

            if (progress < next) {
                requestAnimationFrame(animate);
            }
        }

        animate();
    });

    $: gradient = gradientCssAt(forceProgress || progress);
</script>

<canvas bind:this={canvas} />

<style>
    canvas {
        position: fixed;
        top: env(safe-area-inset-top, 0);
        width: 100%;
        pointer-events: none;
    }
</style>
